import { render, staticRenderFns } from "./NumbersWidget.vue?vue&type=template&id=5d9a8a43&scoped=true"
import script from "./NumbersWidget.vue?vue&type=script&lang=js"
export * from "./NumbersWidget.vue?vue&type=script&lang=js"
import style0 from "./NumbersWidget.vue?vue&type=style&index=0&id=5d9a8a43&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9a8a43",
  null
  
)

export default component.exports